import React from 'react';
import { useMemo } from 'react';

import Select from 'react-select';

function CustomFilter({ column, table }) {
    const firstValue = table.getPreFilteredRowModel().flatRows[0]?.getValue(column.id);
    const columnFilterValue = column.getFilterValue();

    const sortedUniqueValues = useMemo(
        () =>
            typeof firstValue === 'number'
                ? []
                : Array.from(column.getFacetedUniqueValues().keys()).sort(),
        [column.getFacetedUniqueValues()]
    )

    const options = useMemo(() => {
        const options = [];

        if (column.columnDef.meta && column.columnDef.meta.filterComponent == "select") {
            options.push({ value: "", label: "Alle" });
        }

        table.getPreFilteredRowModel().flatRows.forEach(row => {
            const value = row.getValue(column.id);
            if (!options.find(m => m.value == value)) {
                options.push({ value: value, label: value });
            }
        });
        return options;
    }, [column.id, table.getPreFilteredRowModel()]);

    const range = useMemo(() => {
        const range = { min: 9999, max: 0 };
        table.getPreFilteredRowModel().flatRows.forEach(row => {
            const value = row.getValue(column.id);
            if (value < range.min) range.min = value;
            if (value > range.max) range.max = value;
        });
        return range;
    }, [column.id, table.getPreFilteredRowModel()])

    if (column.columnDef.meta) {
        if (column.columnDef.meta.filterComponent == "select") {
            return (
                <Select options={options} value={column.getFilterValue()} classNamePrefix="bv-select" className="bv-select bv-select-sm" placeholder="Auswählen" onChange={
                    (values) => {
                        column.setFilterValue(values);
                    }
                } />
            );
        } else if (column.columnDef.meta.filterComponent == "select-multi") {
            return (
                <Select isMulti closeMenuOnSelect={false} options={options} value={column.getFilterValue()} classNamePrefix="bv-select" className="bv-select bv-select-sm" placeholder="Auswählen" onChange={
                    (values) => {
                        column.setFilterValue(values);
                    }
                } />
            );
        }
    }

    return typeof firstValue === 'number' ? (
        <div className="d-flex">
            <DebouncedInput
                type="number"
                min={range.min}
                max={range.max}
                value={(columnFilterValue)?.[0] ?? ''}
                onChange={value =>
                    column.setFilterValue((old) => [value, old?.[1]])
                }
                placeholder={range.min}
                className="form-control form-control-sm form-control-filter"
            />
            <DebouncedInput
                type="number"
                min={range.min}
                max={range.max}
                value={(columnFilterValue)?.[1] ?? ''}
                onChange={value =>
                    column.setFilterValue((old) => [old?.[0], value])
                }
                placeholder={range.max}
                className="form-control form-control-sm form-control-filter"
            />
        </div>
    ) : (
        <>
            <datalist id={column.id + 'list'}>
                {sortedUniqueValues.slice(0, 5000).map((value) => (
                    <option value={value} key={value} />
                ))}
            </datalist>
            <DebouncedInput
                type="text"
                value={(columnFilterValue ?? '')}
                onChange={value => column.setFilterValue(value)}
                placeholder={`Suche...`}
                className="form-control form-control-sm form-control-filter"
                list={column.id + 'list'}
            />
            <div className="h-1" />
        </>
    )
}

// A debounced input react component
function DebouncedInput({
    value: initialValue,
    onChange,
    debounce = 500,
    ...props
}) {
    const [value, setValue] = React.useState(initialValue)

    React.useEffect(() => {
        setValue(initialValue)
    }, [initialValue])

    React.useEffect(() => {
        const timeout = setTimeout(() => {
            onChange(value)
        }, debounce)

        return () => clearTimeout(timeout)
    }, [value])

    return (
        <input {...props} value={value} onChange={e => setValue(e.target.value)} />
    )
}

export function customFilterFunction(row, _columnId, value) {
    if (value.length == 0) return true;
    if (value.value.length == 0) return true;
    if (Array.isArray(value)) {
        return value.map(m => m.value).indexOf(row.original.StatusString) > -1;
    } else {
        return value.value == row.original.StatusString;
    }
}

export default CustomFilter;